import { SectionLoader } from '@/shared/components/section-loader';

export default function Loading() {
  return <SectionLoader className="tw-h-screen" />;
}
